<div class="audioContainer" [id]="id">
  <div class="audio-player">
    <div class="timeline">
      <div class="progress"></div>
    </div>
    <div class="flex controls">
      <div class="flex-initial flex play-container">
        <div class="toggle-play play">
        </div>
      </div>
      <div class="flex-initial flex time">
        <div class="current">0:00</div>
        <div class="divider">/</div>
        <div class="length"></div>
      </div>
    </div>
  </div>
  </div>
  